import React from "react";
import { useFormikContext } from "formik";
import ToolsIcon from "assets/icons/Tools.svg";
import JobCalendarIcon from "assets/icons/JobCalnedar.svg";

const Step1 = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext();

  const jobTypes = [
    {
      title: "Submit a New Request",
      description:
        "Report a one-time maintenance issue or service need for a specific property.",
      icon: ToolsIcon,
      value: "new_request",
    },
    {
      title: "Create a Recurring Task",
      description:
        "Schedule a task to repeat regularly, ideal for lawn care, cleaning, and seasonal upkeep",
      icon: JobCalendarIcon,
      value: "recurring_task",
    },
  ];

  return (
    <div className=" flex justify-center items-center ">
      <div className=" rounded-[16px]  flex flex-col md:gap-4 gap-3 items-center  ">
        {/* Error message display */}
        {errors.request_type && touched.request_type && (
          <div className="w-full text-center">
            <p className="text-red-500 text-sm font-medium">
              {errors.request_type}
            </p>
          </div>
        )}

        <div className=" flex md:gap-4 gap-3 flex-col md:flex-row  ">
          {jobTypes.map((jobType) => {
            const selected = values.request_type === jobType.value;
            return (
              <div
                key={jobType.value}
                className="relative cursor-pointer max-w-[405px] w-full rounded-[20px]"
                onClick={() => setFieldValue("request_type", jobType.value)}
              >
                {/* Scaling background layer */}
                <div
                  className={`absolute inset-0 rounded-[20px] border transform-gpu transition-all duration-300 will-change-transform ${
                    selected
                      ? "bg-white border-[#3CAB5C] shadow-lg scale-[1.02]"
                      : "bg-[#F6F7F9] border-transparent"
                  } group-[&]:bg-white hover:bg-white hover:shadow-lg hover:scale-[1.02] hover:border-[#ECECEC]`}
                />

                {/* Content layer (static, not scaled) */}
                <div className="relative md:py-6 py-4 md:px-6 px-4">
                  <img
                    className="md:mb-4 mb-2 h-10 w-10 md:h-12 md:w-12"
                    src={jobType.icon}
                    alt={jobType.title}
                  />
                  <h2
                    className="text-[#242424] font-[600] md:mb-4 mb-2"
                    style={{ fontFamily: "Albert Sans" }}
                  >
                    {jobType.title}
                  </h2>
                  <h4
                    className="text-[#242424]"
                    style={{ fontFamily: "Albert Sans" }}
                  >
                    {jobType.description}
                  </h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Step1;
